import React from "react";
import { Outlet } from "react-router-dom";
import Breadcrumbs from "../../components/common/Breadcrumbs";

export default function CTISLayout() {
  return (
    /* flex-grow-1 ensures this area takes up all available space 
       pushing the footer to the absolute bottom of the screen */
    <div className="ctis-main-viewport flex-grow-1 bg-white">
      <div className="mx-auto px-4" style={{ maxWidth: '1320px' }}>
        <div className="mb-4">
           <Breadcrumbs />
        </div>
        <div className="ctis-page-content pb-5">
          <Outlet /> 
        </div>
      </div>
    </div>
  );
}